import { defineComponent as _defineComponent } from 'vue'
import PollList from '@/component/PollList/PollList.vue';
import moment from 'moment';
interface ListItemOptions {
  [key: string]: any;
  id: number | string;
  name: string;
  img: string;
  update_time: number;
  content: string[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConverList',
  props: {
    list: null,
    value: null
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'change', id: number | string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { list: ListItemOptions[]; value?: number | string };



function onSelect(list_item: ListItemOptions) {
  if (!list_item) {
    return;
  }
  console.log(list_item);
  emit('change', list_item.id);
}

function Format(time) {
  return moment(time * 1000).format('MM-DD');
}

return { __sfc: true,props, emit, onSelect, Format, PollList }
}

})